import { useContext, useEffect, useState } from "react";
import { transactionService } from "../../services/transaction.service";
import underscore from "underscore";
import { useRecoilValue } from "recoil";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { transactionmasterDataAtom } from "../../store/transAtom";
import { IoSearchOutline } from "react-icons/io5";
import { Table, Input, Button, Space } from 'antd';
import { DownloadOutlined, FileExcelOutlined } from '@ant-design/icons';
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { useForm } from "react-hook-form";
import moment from "moment";
import LogicContext from "../../Context/LogicContext";


const { Search } = Input;

const columns = [
  {
    title: 'Date',
    key: 'Sales_Order_Date_String',
    dataIndex: 'Sales_Order_Date_String',
    sorter: (a, b) => a.Sales_Order_Date_String.localeCompare(b.Sales_Order_Date_String)
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: "Ref. No",
    dataIndex: "Sales_Order_Ref_No",
    className: "text-primary",
    sorter: (a, b) => (a?.Sales_Order_Ref_No ?? '') - (b?.Sales_Order_Ref_No ?? '')

  },

  {
    title: "Order No.",
    dataIndex: "Sales_Order_No",
    sorter: (a, b) => a.Sales_Order_No.localeCompare(b.Sales_Order_No)
  },

  {
    title: "Sub. Ref. No",
    dataIndex: "Subscription_Ref_No",
    sorter: (a, b) => (a?.Subscription_Ref_No ?? '').toString().localeCompare((b?.Subscription_Ref_No ?? '').toString())
  },


  {
    title: "Type",
    dataIndex: "Gift_Status_Name",
    sorter: (a, b) => a.Gift_Status_Name.localeCompare(b.Gift_Status_Name)
  },

  {
    title: "Coupon",
    dataIndex: "Discount_Coupon_Code",
    sorter: (a, b) => (a?.Discount_Coupon_Code ?? '').localeCompare(b?.Discount_Coupon_Code ?? '')
  },

  {
    title: "Discount",
    dataIndex: "Discount_Amount",
    sorter: (a, b) => (a?.Discount_Amount ?? 0) - (b?.Discount_Amount ?? 0),
    render: (amount) => <span>{formatCustomNumber(amount)} </span>
  },


  {
    title: "Amount",
    dataIndex: "Sales_Order_Amount",
    sorter: (a, b) => (a?.Sales_Order_Amount ?? '') - (b?.Sales_Order_Amount ?? ''),
    render: (amount) => <span>{formatCustomNumber(amount)} </span>

  },

  {
    title: "Status",
    dataIndex: "Sales_Order_Status_Name",
    sorter: (a, b) => a.Sales_Order_Status_Name.localeCompare(b.Sales_Order_Status_Name)
  },


];


function SalesOrderContent(props) {

  const [salesOrderData, setSalesOrderData] = useState({ sales_order: [], sales_order_type: [] });
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const logicContext = useContext(LogicContext);


  const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();




  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    let isMounted = true;
    transactionService.getSalesOrder(props.customer_id).then((res) => {
      const salesOrder = res.data?.sales_order;
      if (isMounted && salesOrder?.length) {
        setSalesOrderData(res.data);
        setFilteredData(salesOrder);

      } else if (isMounted) {
        setFilteredData([]);
        setSalesOrderData({ sales_order: [], sales_order_type: [] });
      }

    });
    return () => {
      isMounted = false;
    };
  }, [props.customer_id]);


  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = salesOrderData.sales_order.filter((record) =>
      Object.values(record).some((text) =>
        String(text).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };



  const searchByDate = async (event) => {

    try {
      const formData = getValues();
      const response = await transactionService.getSalesOrderByData(props.customer_id, formData);
      const list = response?.data;
      if (list?.length) {
        setFilteredData(list);
      } else {
        setFilteredData([]);
        logicContext.showToast("No result found", "info");
        // setFilteredCustomersList([]);
      }
    } catch (error) {

    }
  }


  function handleExpenseAccountChange(type) {
    if (type == 0) {
      return setFilteredData(salesOrderData.sales_order);
    } else {
      var tempList = salesOrderData.sales_order?.filter((item) => item.Gift_Status_Id == type);
      setFilteredData(tempList);
    }
  }

  // Export to CSV function
  const exportToCSV = (data, filename = 'sales-orders.csv') => {
    if (!data || data?.length === 0) {
      alert('No data to export');
      return;
    }

    // Prepare data for export with formatted values
    const exportData = data.map(row => ({
      'Date': row.Sales_Order_Date_String || '',
      'Ref. No': row.Sales_Order_Ref_No || '',
      'Order No.': row.Sales_Order_No || '',
      'Sub. Ref. No': row.Subscription_Ref_No || '',
      'Type': row.Gift_Status_Name || '',
      'Coupon': row.Discount_Coupon_Code || '',
      'Discount': row.Discount_Amount || '',
      'Amount': row.Sales_Order_Amount || '',
      'Status': row.Sales_Order_Status_Name || ''
    }));

    // Create CSV content
    const headers = Object.keys(exportData[0]);
    const csvContent = [
      headers.join(','),
      ...exportData.map(row =>
        headers.map(header => {
          const value = row[header];
          // Wrap in quotes if contains comma or quotes
          return typeof value === 'string' && (value.includes(',') || value.includes('"'))
            ? `"${value.replace(/"/g, '""')}"`
            : value;
        }).join(',')
      )
    ].join('\n');

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // Export to Excel function
  const exportToExcel = async (data, filename = 'sales-orders.xlsx') => {
    if (!data || data?.length === 0) {
      alert('No data to export');
      return;
    }

    try {
      // Dynamically import XLSX if not already loaded
      let XLSX;
      if (typeof window.XLSX === 'undefined') {
        // Try to load XLSX dynamically
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
        document.head.appendChild(script);

        await new Promise((resolve, reject) => {
          script.onload = resolve;
          script.onerror = reject;
        });

        XLSX = window.XLSX;
      } else {
        XLSX = window.XLSX;
      }

      const exportData = data.map(row => ({
        'Date': row.Sales_Order_Date_String || '',
        'Ref. No': row.Sales_Order_Ref_No || '',
        'Order No.': row.Sales_Order_No || '',
        'Sub. Ref. No': row.Subscription_Ref_No || '',
        'Type': row.Gift_Status_Name || '',
        'Coupon': row.Discount_Coupon_Code || '',
        'Discount': row.Discount_Amount || '',
        'Amount': row.Sales_Order_Amount || '',
        'Status': row.Sales_Order_Status_Name || ''
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Set column widths
      const wscols = [
        { wch: 12 }, // Date
        { wch: 15 }, // Ref. No
        { wch: 18 }, // Order No.
        { wch: 15 }, // Sub. Ref. No
        { wch: 12 }, // Type
        { wch: 15 }, // Coupon
        { wch: 12 }, // Discount
        { wch: 15 }, // Amount
        { wch: 15 }  // Status
      ];
      worksheet['!cols'] = wscols;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sales Orders');
      XLSX.writeFile(workbook, filename);

    } catch (error) {
      console.error('Error loading XLSX library:', error);
      alert('Could not load Excel export library. Please try again or use CSV export.');
    }
  };

  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: filteredData?.length || 0,
    // onChange: (page, pageSize) => {
    //   const newList = tableDataList.slice(0, pageSize);
    //   setTableList(newList);
    // },
  };

  const handleRowClick = (record) => {
    navigate(`/${currModuleId}/${currModuleName}/sales-order/details/${record?.Sales_Order_Ref_No}`);
  };




  return (
    <>
      <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Sales Order</h1>

        <section>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-5 items-end mb-8">
            {/* Search Input */}
            <div className="relative w-full">
              <Search
                placeholder="Search..."
                onSearch={handleSearch}
                onChange={(e) => handleSearch(e.target.value)}
                value={searchText}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
              />
              <IoSearchOutline className="absolute top-1/2 left-3 transform -translate-y-1/2 h-5 w-5 text-gray-500" />
            </div>

            {/* Type Select */}
            <div className="w-full">
              <label htmlFor="expense_account" className="flex text-sm font-medium text-gray-700 mb-1">
                Type
              </label>
              <select
                id="expense_account"
                defaultValue=""
                className="w-full p-3 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                onChange={(e) => handleExpenseAccountChange(e.target.value)}
              >
                {salesOrderData?.sales_order_type?.map((type, idx) => (
                  <option key={idx} value={type.order_type_id}>
                    {type?.order_type_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Date Search */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="flex text-sm font-medium text-gray-700 mb-1">From Date</label>
                <input
                  defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                  {...register("fr_date")}
                  className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  type="date"
                />
              </div>
              <div>
                <label className="flex text-sm font-medium text-gray-700 mb-1">To Date</label>
                <input
                  {...register("to_date")}
                  defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                  className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  type="date"
                />
              </div>
            </div>

            <div className="flex items-end">
              <button
                onClick={() => searchByDate()}
                type="button"
                className="w-full bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition duration-200 font-medium"
              >
                Search
              </button>
            </div>

            {/* Export Buttons */}
            <div className="w-full">
              <Space direction="vertical" size="small" className="w-full">
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={() => exportToCSV(filteredData)}
                  disabled={filteredData?.length === 0}
                  className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-200 flex items-center justify-center"
                >
                  Export CSV
                </Button>
                <Button
                  type="default"
                  icon={<FileExcelOutlined />}
                  onClick={() => exportToExcel(filteredData)}
                  disabled={filteredData?.length === 0}
                  className="w-full border border-gray-300 text-gray-700 py-2 rounded-lg hover:bg-gray-100 transition duration-200 flex items-center justify-center"
                >
                  Export Excel
                </Button>
              </Space>
              {filteredData?.length > 0 && (
                <span className="flex mt-2 text-sm text-gray-600">
                  ({filteredData?.length} records)
                </span>
              )}
            </div>
          </div>
        </section>

        {/* Table */}
        <div className="bg-gray-50 rounded-lg shadow-sm overflow-hidden">
          <Table
            key={filteredData?.length}
            columns={columns}
            dataSource={filteredData}
            pagination={paginationOptions}
            rowClassName="cursor-pointer hover:bg-gray-100 transition"
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
          />
        </div>
      </div>
    </>
  );
}

export default SalesOrderContent;